import React from 'react';
import PropTypes from 'prop-types';

export default function OrganizationFormModal({
  open,
  onClose,
  onSubmit,
  loading,
  title = 'Add Organization',
  submitLabel = 'Submit',
  children,
}) {
  if (!open) return null;

  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(var(--hc-black-rgb), 0.25)' }}>
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content rounded-4 shadow-lg">
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title fw-bold mb-0">{title}</h5>
          </div>
          <form onSubmit={onSubmit}>
            <div className="modal-body pt-0">
              {children}
            </div>
            <div className="modal-footer border-0 pt-0 d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary px-4 rounded-3"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn hc-bg-primary text-white px-4 rounded-3 fw-semibold d-flex align-items-center gap-2"
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                ) : null}
                {submitLabel}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

OrganizationFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  submitLabel: PropTypes.string,
  children: PropTypes.node,
};
